import React from 'react';
import { Box, Card, CardContent, Chip, CircularProgress, Grid, Typography } from '@material-ui/core';
import { Banner } from '../../components/Portal';
import { privateApi } from '../../lib/privateApi';
import { useAuth } from '../../lib/useAuth';
import { checkErrorStatusCode, errorLog, formatDate, va } from '../../utils/commonUtils';
import calImg from './images/ImpDates.jpg';
import { initFalse } from '../../utils/constants';


type PortalHomeProps = {
  title: string;
  description?: string;
  children: React.ReactNode;
}

type TrancheProps = {
  deadlineDate: string;
  fundsDeadLineDate: string;
  id: number;
  isCurrent: boolean;
  projectFundingDate: string;
  trancheNumber: number;
}

const ImportantDates = () => {
  const rowsPerPage = 3;
  const [loading, setLoading] = React.useState<boolean>(initFalse);
  const [importantDates, setImportantDates] = React.useState<TrancheProps[]>([]);
  const {logout} = useAuth();
  const getTranches = async () => {
    try {
      setLoading(!initFalse);
      const response = await privateApi.get(`/tranche/important?rowsPerPage=${rowsPerPage}`);
      setImportantDates(response.data);
      setLoading(initFalse);
    } catch (e) {
      errorLog(e);
      if (checkErrorStatusCode(e)) {
        logout();
      }
    }
  };
  const firstRun = () => {
    if (!va(importantDates)) {
      getTranches()
        .then();
    }
  };
  const boxProps = {
    className: "floatLeft w100 mt10",
    display: "flex",
    justifyContent: "space-between",
    style: {padding: '0 15px'},
  };

  React.useEffect(firstRun, [])

  return (
    <Card className="boxShadow">
      <CardContent className="cardPadding0">
        <Grid container>
          <Grid item xs={12}>
            <Box style={{padding: '10px 15px'}} className="floatLeft w100">
              <img src={calImg} alt=" Important Dates Icon" className="floatLeft" />
              <Typography component="strong" variant="h6" color="primary" className="floatLeft mt20 ml15">
                Important Dates
              </Typography>
            </Box>
          </Grid>
          {
            importantDates.map(({fundsDeadLineDate, isCurrent, projectFundingDate, trancheNumber}, index) => {
              return (
                <Grid item xs={12} key={index} className="lastItemMb20">
                  <span className="hLine" />
                  <Box  {...boxProps}>
                    <Typography color="primary" variant="caption" component="strong">
                      Tranche {trancheNumber}
                    </Typography>
                    {isCurrent && <Chip label="Current" color="primary" />}
                  </Box>
                  <Box {...boxProps}>
                    <Typography className="textLightGray" variant="caption">Funds/Paperwork Deadline:</Typography>
                    <Typography color={isCurrent ? 'error' : 'initial'}>{formatDate(fundsDeadLineDate)}</Typography>
                  </Box>
                  <Box {...boxProps} >
                    <Typography className="textLightGray" variant="caption">Projected Funding:</Typography>
                    <Typography color={isCurrent ? 'error' : 'initial'}>{formatDate(projectFundingDate)}</Typography>
                  </Box>
                </Grid>
              )
            })
          }
          {
            importantDates.length === 0 && loading &&
            <Grid alignItems="center" item xs={12} className="lastItemMb20 textCenter">
              <CircularProgress color="inherit" />
            </Grid>
          }
        </Grid>
      </CardContent>
    </Card>
  )
};

const PortalHome: React.FC<PortalHomeProps> = ({title, description, children}) => {
  return (
    <Grid container spacing={2}>
      <Banner title={title} description={description as string} />
      <Grid container spacing={4}>
        <Grid item xs={12} md={12} lg={8}>
          {children}
        </Grid>
        <Grid item xs={12} md={12} lg={4}>
          <ImportantDates />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PortalHome;
